<template>
  <div id="workOrder">
    <!-- 搜索 -->
    <div class="flex justify-end align-center" style="height: 32px;">
     <!-- <el-button style='background-color:#1BADE8;color: #FFFFFF;height: 32px;padding: 0 20px;'>添加</el-button> -->
    </div>
    <!-- 分界线 -->
    <div class="" style="height: 10px;background-color: #F5F6FA;width: 100%;margin-top: 16px;margin-bottom: 24px;"></div>

    <div class="flex flex-direction justify-between" style="min-height: 780px;">
      <div>
        <!-- 表格 -->
        <el-table :data="tableData" stripe style="width: 100%">
          <el-table-column type="index" align="center" label="序号" width="100">
          </el-table-column>
          <el-table-column prop="content" align="center" label="工单内容" width="100">
            <template slot-scope="scope">
              <el-button @click='replyGdnr(scope.row.content)' type="text" size="small">
                查看
              </el-button>
            </template>
          </el-table-column>
          <el-table-column prop="contact" align="center" label="联系方式">
          </el-table-column>
          <el-table-column prop="ip" align="center" label="IP地址">
          </el-table-column>
          <el-table-column prop="dev" align="center" width="280" label="设备号">
          </el-table-column>
          <el-table-column prop="create_time" align="center" label="提交时间">
          </el-table-column>
          <el-table-column prop="answer" align="center" label="回复内容"  width="100">
            <template slot-scope="scope">
              <el-button @click="replyNr(scope.row.answer)" type="text" size="small">
                查看
              </el-button>
            </template>
          </el-table-column>
          <el-table-column prop="answer_time" align="center" label="回复时间">
          </el-table-column>
          <el-table-column prop="address" align="center" label="操作">
            <template slot-scope="scope">
              <el-button @click="replyGd(scope.row.id)" type="text" size="small">
                回复工单
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <el-pagination id='pagebox' style="margin-top: 30px;text-align: center;" background
        @current-change="handleCurrentChange" :current-page="tablePage" :page-size="tableLimit" :page-sizes="[100, 200, 300, 400]"
        layout="total, prev, pager, next, jumper" :total="tableCount">
      </el-pagination>
    </div>


    <!-- 回复工单 -->
    <el-dialog
      title="回复工单"
      :visible.sync="dialogVisible"
      width="30%"
      id="workbox"
      >
      <el-input
        type="textarea"
        :rows="5"
        placeholder="请输入内容"
        v-model="gdHfdata.content">
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button style="height: 32px;padding: 0 20px;background-color: #F5F6F7;" @click="dialogVisible = false">取 消</el-button>
        <el-button style="height: 32px;padding: 0 20px;background-color: #1BADE8;color: #FFFFFF;" type="primary" @click="replyGd_">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 查看回复的内容 -->
    <el-dialog
      title="查看回复内容"
      :visible.sync="dialogVisible1"
      width="30%"
      id="workBox_"
      >
      <el-input
        type="textarea"
        :rows="5"
        :disabled="true"
        :placeholder="replyNR"
        >
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button style="height: 32px;padding: 0 20px;background-color: #1BADE8;color: #FFFFFF;" type="primary" @click="dialogVisible1 = false">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 查看工单内容 -->
    <el-dialog
      title="查看工单内容"
      :visible.sync="dialogVisible2"
      width="30%"
      id="workBox_"
      >
      <el-input
        type="textarea"
        :rows="5"
        :disabled="true"
        :placeholder="replyGD"
        >
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button style="height: 32px;padding: 0 20px;background-color: #1BADE8;color: #FFFFFF;" type="primary" @click="dialogVisible2 = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>

</template>

<script>
  export default {
    name: 'workOrder',
    created() {
      this.getTable()
    },
    data() {
      return {
        dialogVisible:false, //回复工单
        textarea:'',//回复工单
        dialogVisible1:false,//查看回复内容
        dialogVisible2:false,//查看工单内容

        search: '',

        /* 获取表格数据发送参数 */
        sendData: {
          act: 'userFB',
          page: 1,
          limit: 15
        },
        /* 渲染页面参数 */
        tablePage: 1, //表格--当前页
        tableLimit: 10, //表格--当前页数据条数尺寸
        tableCount: 10, //表格--数据总条数
        tableData: [], //表格--数据列表

        replyGD:'暂无内容',//回复工单
        replyNR:'暂无回复',//回复内容

        /* 工单回复请求参数 */
        gdHfdata:{
          act:'userFBA',
          id:'',
          content:''
        }

      }

    },
    methods: {
      /******************* 获取数据列表 */
      getTable() {
        this.$api.dataList.userTable(this.sendData).then(res => {
          //console.log(res)
          if (res.code == '1') {
            this.tablePage = res.data.page
            this.tableLimit = res.data.limit
            this.tableCount = res.data.count
            this.tableData = res.data.list
          }
        })
      },

      /******************* 切换页面  */
      handleCurrentChange(val) {
        //console.log(`当前页: ${val}`);
        this.sendData.page = val
        this.getTable()
      },
      /* 查看工单内容 */
      replyGdnr(text){
        this.replyGD=text
        this.dialogVisible2=true
      },
      /* 查看回复内容 */
      replyNr(text){
        if(text){
          this.replyNR=text
        }
        this.dialogVisible1=true
      },
      /* 回复工单 */
      replyGd(id){
        this.gdHfdata.id=id
        //console.log(id)
        this.dialogVisible=true
      },
      /* 回复工单请求 */
        replyGd_(){
          this.$api.dataList.userTable(this.gdHfdata).then(res=>{
            //console.log("回复工单：",res)
            if(res.code=='1'){
              this.$message({
                message: res.info,
                type: 'success'
              })
              this.dialogVisible=false
              this.sendData.page=1
              this.getTable()
            }else{
              this.$message({
                message: res.info,
                type: 'error'
              })
            }
          })
        },
      /*************************************** */
    }
  }
</script>

<style>
  #workOrder {
    background-color: #FFFFFF;
    padding: 24px;
    border-radius: 6px;
    position: relative;
  }

  #workOrder #pagebox {

  }

  /****************************/
  /* 回复工单内容 */
  #workbox .el-dialog{
      border-radius: 6px !important;
  }
  #workbox .el-dialog__header,
  #workBox_ .el-dialog__header{
    text-align: left;

  }
  #workbox .el-dialog__header .el-dialog__title,
  #workBox_ .el-dialog__header .el-dialog__title{
    color: #333333 !important;
    font-size: 14px !important;
    font-weight: 700 !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/workOrder.vue